import React, { useEffect, lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import TLAHomepage from "./TLAHomepage.jsx";
import "./global.css";
import "./careers/careers.css";

// Careers section is lazy-loaded — keeps the homepage initial bundle smaller.
const CareersLayout = lazy(() => import("./careers/CareersLayout.jsx"));
const CareersIndex = lazy(() => import("./careers/CareersIndex.jsx"));
const JobDetail = lazy(() => import("./careers/JobDetail.jsx"));
const ApplicationForm = lazy(() => import("./careers/ApplicationForm.jsx"));
const GeneralApplication = lazy(() => import("./careers/GeneralApplication.jsx"));
const ThankYou = lazy(() => import("./careers/ThankYou.jsx"));

// SPA page-view tracker. The gtag config in index.html disables automatic
// page_view, so each route change reports here instead. No-ops if gtag isn't
// available (e.g. ad-blockers, dev with no GA ID).
function GAPageTracker() {
  const location = useLocation();
  const measurementId = import.meta.env.VITE_GA_ID;
  useEffect(() => {
    if (!measurementId || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
      send_to: measurementId,
    });
  }, [location, measurementId]);
  return null;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <GAPageTracker />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<TLAHomepage />} />
          <Route path="/careers" element={<CareersLayout />}>
            <Route index element={<CareersIndex />} />
            <Route path="general" element={<GeneralApplication />} />
            <Route path="thank-you" element={<ThankYou />} />
            <Route path=":slug" element={<JobDetail />} />
            <Route path=":slug/apply" element={<ApplicationForm />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
